import classNames from "classnames";
import styles from "./AscFiltersCard.module.scss";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import AscLink from "../../AscLink/AscLink";
import AscTextInput from "../../AscInputFields/AscTextInput/AscTextInput";
import AscSelectInput from "../../AscInputFields/AscSelectInput/AscSelectInput";
import AscCheckBox from "../../AscInputFields/AscCheckBox/AscCheckBox";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";

export interface AscFiltersCardProps {
  className?: string;
  handlerFilters?: any;
  resetAllFilters?: () => void;
  filteredOptions?: {
    companies: {
      _count: {
        employees: number;
      };
      employees: string;
    }[];
    industries: {
      tagId: string;
      _count: number;
      name: string;
    }[];
    countries: [];
  };
}

export default function AscFiltersCard({
  className,
  filteredOptions,
  resetAllFilters,
  handlerFilters,
}: AscFiltersCardProps) {
  const router = useRouter();
  const [isFullView, setIsFullView] = useState(false);
  const [industryFilters, setIndustryFilters] = useState<string[]>([]);

  useEffect(() => {
    if (router.query.industry) {
      setIndustryFilters(String(router.query.industry).split(","));
    }
  }, [router.query.industry]);

  const tagNamehandler = (tagName: string) => {
    const updatedFilters = [...industryFilters];

    if (updatedFilters.includes(tagName)) {
      const index = updatedFilters.indexOf(tagName);
      updatedFilters.splice(index, 1);
    } else {
      updatedFilters.push(tagName);
    }
    setIndustryFilters(updatedFilters);
    const payload = { industry: updatedFilters };
    handlerFilters(payload);
  };
  const handleClear = () => {
    if (resetAllFilters) {
      resetAllFilters();
    }
    setIndustryFilters([]);
  };

  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      contentClassName={styles.cardContent}
      title={null}
      coverImageUrl={null}
    >
      <div className={styles.header}>
        <AscParagraph className={styles.title}>Filters</AscParagraph>
        {router.query.keyword ||
        industryFilters.length > 0 ||
        router.query.isRemote ||
        router.query.country ? (
          <AscLink className={styles.clear} onClick={handleClear}>
            Clear
          </AscLink>
        ) : null}
      </div>
      <div className={styles.content}>
        <div className={styles.filterItem}>
          <AscParagraph className={styles.label}>Keyword</AscParagraph>
          <AscTextInput
            placeholder="Company, location..."
            value={router.query.keyword?.toString() || ""}
            onChange={(e) => handlerFilters({ keyword: e.target.value })}
          />
        </div>
        <div className={styles.filterItem}>
          <AscParagraph className={styles.label}>Location</AscParagraph>
          <AscSelectInput
            value={router.query.country || ""}
            placeholder="Choose a country"
            onChange={(value) => handlerFilters({ country: value || "" })}
            isClearSelectedOptions={router.query.country === undefined}
          >
            {filteredOptions?.countries?.map((option, index) => (
              <AscSelectInput.Option
                key={index}
                value={option}
                label={option}
              />
            ))}
          </AscSelectInput>
          <div className={styles.checkbox}>
            <AscCheckBox
              checked={router.query.isRemote === "true"}
              onChange={() => {
                const newIsRemote = router.query.isRemote !== "true";
                handlerFilters({ isRemote: newIsRemote });
              }}
            />
            <AscParagraph className={styles.checkboxLabel}>
              Remote OK
            </AscParagraph>
          </div>
        </div>
        {isFullView && (
          <>
            <div className={styles.filterItem}>
              <AscParagraph className={styles.label}>Industry</AscParagraph>
              <div className={styles.filterCheckboxes}>
                {filteredOptions?.industries?.map((industry) => (
                  <div className={styles.filterCheckbox} key={industry.name}>
                    <AscCheckBox
                      checked={industryFilters.includes(industry.name)}
                      onChange={() => tagNamehandler(industry.name)}
                    />
                    <AscParagraph className={styles.checkboxLabel}>
                      {industry.name}
                    </AscParagraph>
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.filterItem}>
              <AscParagraph className={styles.label}>Company Size</AscParagraph>
              <div className={styles.filterCheckboxes}>
                {filteredOptions?.companies?.map((company, index) => (
                  <div className={styles.filterCheckbox} key={index}>
                    <AscCheckBox
                      checked={router.query.companySize === company.employees}
                      onChange={() => {
                        const newCompanySize =
                          router.query.companySize !== company.employees
                            ? company.employees
                            : "";
                        handlerFilters({ companySize: newCompanySize });
                      }}
                    />
                    <AscParagraph className={styles.checkboxLabel}>
                      {company.employees}
                    </AscParagraph>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
      {!isFullView && (
        <div className={styles.footer}>
          <AscLink
            className={styles.seeMore}
            onClick={() => setIsFullView(true)}
            href="#"
          >
            See more filters
          </AscLink>
        </div>
      )}
    </AscGenericCard>
  );
}
